import useDialog from 'components/Dialog/useDialog';
import { ROLE_ADMIN, ROLE_MENTOR, ROLE_USER } from 'constants/roles';
import { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  ROUTE_STARTUP_PATH, routes, routesAdmin,
  routesMentor, routesPosition, routesStartup,
} from 'routes';

export const useSessionRoutes = (sessionChecked, isAuthenticated, user, platform, initPlatform) => {
  const literalsErrors = useSelector(state => state.i18n.literals.outputErrors);
  const { dialog } = useDialog();

  const generateRoutes = useCallback((auxUser) => {
    if (!auxUser.role) return routes.map(r => ({ ...r, aside: false }));
    const roleRoutes = {
      [ROLE_USER]: routesStartup,
      [ROLE_MENTOR]: routesMentor,
      [ROLE_ADMIN]: routesAdmin,
    };
    const userRoutes = auxUser.role.flatMap(role => roleRoutes[role] || []);

    const allRoutes = [...routes, ...userRoutes, ...routesPosition];

    const embeddedRoutes = allRoutes
      .filter(route => route.embed)
      .map(route => ({
        ...route,
        path: ROUTE_STARTUP_PATH.setEmbed(route.path),
        aside: false,
      }));

    return [...allRoutes, ...embeddedRoutes];
  }, []);

  useEffect(() => {
    const shouldInitPlatform = sessionChecked && !isAuthenticated && !platform.loaded && !platform.loading;

    if (shouldInitPlatform) {
      initPlatform().catch(async () => {
        await dialog({
          type: 'error',
          text: literalsErrors.internal,
        });
      });
    }
  }, [sessionChecked, isAuthenticated, platform, initPlatform, dialog, literalsErrors]);

  return generateRoutes(user);
};
